var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ ratio: _vm.ratio },style:(_vm.ratio && { padding: ((_vm.ratio * 100) + "% 0 0") })},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }